import { render, staticRenderFns } from "./OrderInfoForm.vue?vue&type=template&id=783d515f&"
import script from "./OrderInfoForm.vue?vue&type=script&lang=js&"
export * from "./OrderInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoForm.vue?vue&type=style&index=0&id=783d515f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports